[
  {
    "code": "IQ-AN",
    "name": "Al Anbar"
  },
  {
    "code": "IQ-BA",
    "name": "Al Basrah"
  },
  {
    "code": "IQ-MU",
    "name": "Al Muthanná"
  },
  {
    "code": "IQ-QA",
    "name": "Al Qadisiyah"
  },
  {
    "code": "IQ-NA",
    "name": "An Najaf"
  },
  {
    "code": "IQ-AR",
    "name": "Arbil"
  },
  {
    "code": "IQ-SU",
    "name": "As Sulaymaniyah"
  },
  {
    "code": "IQ-TS",
    "name": "At Ta'mim"
  },
  {
    "code": "IQ-BB",
    "name": "Babil"
  },
  {
    "code": "IQ-BG",
    "name": "Baghdad"
  },
  {
    "code": "IQ-DA",
    "name": "Dahuk"
  },
  {
    "code": "IQ-DQ",
    "name": "Dhi Qar"
  },
  {
    "code": "IQ-DI",
    "name": "Diyalá"
  },
  {
    "code": "IQ-KA",
    "name": "Karbala'"
  },
  {
    "code": "IQ-MA",
    "name": "Maysan"
  },
  {
    "code": "IQ-NI",
    "name": "Ninawá"
  },
  {
    "code": "IQ-SD",
    "name": "Salah ad Din"
  },
  {
    "code": "IQ-WA",
    "name": "Wasit"
  }
]